/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CommentShowIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Comment Show',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M14.51758,16.7168c-2.66504,0-5.26758-2.38867-5.26758-3.77441,0-1.15039,1.59375-2.73438,3.02637-3.43848.68457-.34375,1.4502-.53125,2.21484-.54004,2.8291,0,5.25879,2.66895,5.25879,3.97852,0,1.38574-2.58594,3.77441-5.23242,3.77441ZM14.5,10.46387c-.5293.00586-1.06934.13867-1.55176.38184-.00293.00098-.00488.00195-.00781.00391-1.25488.61523-2.14941,1.7793-2.19141,2.10547.09277.50195,1.83496,2.26172,3.76855,2.26172,1.91992,0,3.64258-1.75879,3.7334-2.29688-.08105-.45312-1.70215-2.45605-3.75098-2.45605ZM12.61035,10.17578h.00977-.00977Z"
      fill="currentColor"
    />
    <path
      d="M14.43128,12.3544c.09764.2541.31041.44941.57222.52485.09767.02814.32507.07156.57125-.03069.3032-.12594.60919.13381.51337.44783-.09774.32033-.29755.61706-.60424.84139-.52399.38327-1.25696.41124-1.8077.06751-.90174-.56279-1.03211-1.76606-.34774-2.50647.16964-.18353.37133-.31817.58846-.40424.28782-.11409.60689.17131.50468.46356-.06525.18656-.06712.39632.00971.59627Z"
      fill="currentColor"
    />
    <path
      d="M6.25,19c-.09961,0-.19922-.01953-.29395-.05957-.27637-.11816-.45605-.38965-.45605-.69043v-3.25h-.75c-2.06738,0-3.75-1.68262-3.75-3.75v-5.5c0-2.06738,1.68262-3.75,3.75-3.75h10.5c2.06738,0,3.75,1.68262,3.75,3.75v2.04199c0,.41406-.33594.75-.75.75s-.75-.33594-.75-.75v-2.04199c0-1.24023-1.00977-2.25-2.25-2.25H4.75c-1.24023,0-2.25,1.00977-2.25,2.25v5.5c0,1.24023,1.00977,2.25,2.25,2.25h1.5c.41406,0,.75.33594.75.75v2.23633l.89453-.86133c.29883-.28711.77344-.27832,1.06055.01953.28711.29883.27832.77344-.01953,1.06055l-2.16504,2.08496c-.14258.1377-.33008.20996-.52051.20996Z"
      fill="currentColor"
    />
  </svg>`;
};
